import ButtonContainer from "../../components/Simple/ButtonContainer";
import SMCButton from "../../components/Simple/SMCButton";
import React from "react";
import ButtonsContainerStyles from './ButtonsContainerStyles';
import {useTranslation} from "react-i18next";

function VerifyButtonsContainer({
                           disabled,
                           onClickSaveButton,
                           onClickCancelButton
                       }) {
    const classes = ButtonsContainerStyles();
    const { t } = useTranslation();

    return (
        <ButtonContainer className={classes.verifyButtonsContainer} addTopBorder>
            <div>
                <SMCButton
                    className={classes.cancelButton}
                    disabled={disabled}
                    onClick={onClickCancelButton}
                >
                    <div>{t('SMC_GEN_CANCEL')}</div>
                </SMCButton>
                <SMCButton
                    className={classes.saveButton}
                    disabled={disabled}
                    onClick={onClickSaveButton}
                    textStyle={{color: 'white'}}
                >
                    {t('SMC_GEN_SAVE')}
                </SMCButton>
            </div>
        </ButtonContainer>
    );
}


export default VerifyButtonsContainer;